module.exports = __webpack_public_path__ + "img/Nelson-Vidal.7137f71c.jpg";